export const englishWordsList = ['Abandon', 'Ability', 'Able', 'About', 'Above', 'Absent', 'Absorb', 'Abstract', 'Absurd', 'Abuse', 'Access', 'Accident', 'Account', 'Accuse', 'Achieve', 'Acid', 'Acoustic', 'Acquire', 'Across', 'Act', 'Action', 'Actor', 'Actress', 'Actual', 'Adapt', 'Add', 'Addict', 'Address', 'Adjust', 'Admit', 'Adult', 'Advance', 'Advice', 'Aerobic', 'Affair', 'Afford', 'Afraid', 'Again', 'Age', 'Agent', 'Agree', 'Ahead', 'Aim', 'Air', 'Airport', 'Aisle', 'Alarm', 'Album', 'Alcohol', 'Alert', 'Alien', 'All', 'Alley', 'Allow', 'Almost', 'Alone', 'Alpha', 'Already', 'Also', 'Alter', 'Always', 'Amateur', 'Amazing', 'Among', 'Amount', 'Amused', 'Analyst', 'Anchor', 'Ancient', 'Anger', 'Angle', 'Angry', 'Animal', 'Ankle', 'Announce', 'Annual', 'Another', 'Answer', 'Antenna', 'Antique', 'Anxiety', 'Any', 'Apart', 'Apology', 'Appear', 'Apple', 'Approve', 'April', 'Arch', 'Arctic', 'Area', 'Arena', 'Argue', 'Arm', 'Armed', 'Armor', 'Army', 'Around', 'Arrange', 'Arrest', 'Arrive', 'Arrow', 'Art', 'Artefact', 'Artist', 'Artwork', 'Ask', 'Aspect', 'Assault', 'Asset', 'Assist', 'Assume', 'Asthma', 'Athlete', 'Atom', 'Attack', 'Attend', 'Attitude', 'Attract', 'Auction', 'Audit', 'August', 'Aunt', 'Author', 'Auto', 'Autumn', 'Average', 'Avocado', 'Avoid', 'Awake', 'Aware', 'Away', 'Awesome', 'Awful', 'Awkward', 'Axis', 'Baby', 'Bachelor', 'Bacon', 'Badge', 'Bag', 'Balance', 'Balcony', 'Ball', 'Bamboo', 'Banana', 'Banner', 'Bar', 'Barely', 'Bargain', 'Barrel', 'Base', 'Basic', 'Basket', 'Battle', 'Beach', 'Bean', 'Beauty', 'Because', 'Become', 'Beef', 'Before', 'Begin', 'Behave', 'Behind', 'Believe', 'Below', 'Belt', 'Bench', 'Benefit', 'Best', 'Betray', 'Better', 'Between', 'Beyond', 'Bicycle', 'Bid', 'Bike', 'Bind', 'Biology', 'Bird', 'Birth', 'Bitter', 'Black', 'Blade', 'Blame', 'Blanket', 'Blast', 'Bleak', 'Bless', 'Blind', 'Blood', 'Blossom', 'Blouse', 'Blue', 'Blur', 'Blush', 'Board', 'Boat', 'Body', 'Boil', 'Bomb', 'Bone', 'Bonus', 'Book', 'Boost', 'Border', 'Boring', 'Borrow', 'Boss', 'Bottom', 'Bounce', 'Box', 'Boy', 'Bracket', 'Brain', 'Brand', 'Brass', 'Brave', 'Bread', 'Breeze', 'Brick', 'Bridge', 'Brief', 'Bright', 'Bring', 'Brisk', 'Broccoli', 'Broken', 'Bronze', 'Broom', 'Brother', 'Brown', 'Brush', 'Bubble', 'Buddy', 'Budget', 'Buffalo', 'Build', 'Bulb', 'Bulk', 'Bullet', 'Bundle', 'Bunker', 'Burden', 'Burger', 'Burst', 'Bus', 'Business', 'Busy', 'Butter', 'Buyer', 'Buzz', 'Cabbage', 'Cabin', 'Cable', 'Cactus', 'Cage', 'Cake', 'Call', 'Calm', 'Camera', 'Camp', 'Can', 'Canal', 'Cancel', 'Candy', 'Cannon', 'Canoe', 'Canvas', 'Canyon', 'Capable', 'Capital', 'Captain', 'Car', 'Carbon', 'Card', 'Cargo', 'Carpet', 'Carry', 'Cart', 'Case', 'Cash', 'Casino', 'Castle', 'Casual', 'Cat', 'Catalog', 'Catch', 'Category', 'Cattle', 'Caught', 'Cause', 'Caution', 'Cave', 'Ceiling', 'Celery', 'Cement', 'Census', 'Century', 'Cereal', 'Certain', 'Chair', 'Chalk', 'Champion', 'Change', 'Chaos', 'Chapter', 'Charge', 'Chase', 'Chat', 'Cheap', 'Check', 'Cheese', 'Chef', 'Cherry', 'Chest', 'Chicken', 'Chief', 'Child', 'Chimney', 'Choice', 'Choose', 'Chronic', 'Chuckle', 'Chunk', 'Churn', 'Cigar', 'Cinnamon', 'Circle', 'Citizen', 'City', 'Civil', 'Claim', 'Clap', 'Clarify', 'Claw', 'Clay', 'Clean', 'Clerk', 'Clever', 'Click', 'Client', 'Cliff', 'Climb', 'Clinic', 'Clip', 'Clock', 'Clog', 'Close', 'Cloth', 'Cloud', 'Clown', 'Club', 'Clump', 'Cluster', 'Clutch', 'Coach', 'Coast', 'Coconut', 'Code', 'Coffee', 'Coil', 'Coin', 'Collect', 'Color', 'Column', 'Combine', 'Come', 'Comfort', 'Comic', 'Common', 'Company', 'Concert', 'Conduct', 'Confirm', 'Congress', 'Connect', 'Consider', 'Control', 'Convince', 'Cook', 'Cool', 'Copper', 'Copy', 'Coral', 'Core', 'Corn', 'Correct', 'Cost', 'Cotton', 'Couch', 'Country', 'Couple', 'Course', 'Cousin', 'Cover', 'Coyote', 'Crack', 'Cradle', 'Craft', 'Cram', 'Crane', 'Crash', 'Crater', 'Crawl', 'Crazy', 'Cream', 'Credit', 'Creek', 'Crew', 'Cricket', 'Crime', 'Crisp', 'Critic', 'Crop', 'Cross', 'Crouch', 'Crowd', 'Crucial', 'Cruel', 'Cruise', 'Crumble', 'Crunch', 'Crush', 'Cry', 'Crystal', 'Cube', 'Culture', 'Cup', 'Cupboard', 'Curious', 'Current', 'Curtain', 'Curve', 'Cushion', 'Custom', 'Cute', 'Cycle', 'Dad', 'Damage', 'Damp', 'Dance', 'Danger', 'Daring', 'Dash', 'Daughter', 'Dawn', 'Day', 'Deal', 'Debate', 'Debris', 'Decade', 'December', 'Decide', 'Decline', 'Decorate', 'Decrease', 'Deer', 'Defense', 'Define', 'Defy', 'Degree', 'Delay', 'Deliver', 'Demand', 'Demise', 'Denial', 'Dentist', 'Deny', 'Depart', 'Depend', 'Deposit', 'Depth', 'Deputy', 'Derive', 'Describe', 'Desert', 'Design', 'Desk', 'Despair', 'Destroy', 'Detail', 'Detect', 'Develop', 'Device', 'Devote', 'Diagram', 'Dial', 'Diamond', 'Diary', 'Dice', 'Diesel', 'Diet', 'Differ', 'Digital', 'Dignity', 'Dilemma', 'Dinner', 'Dinosaur', 'Direct', 'Dirt', 'Disagree', 'Discover', 'Disease', 'Dish', 'Dismiss', 'Disorder', 'Display', 'Distance', 'Divert', 'Divide', 'Divorce', 'Dizzy', 'Doctor', 'Document', 'Dog', 'Doll', 'Dolphin', 'Domain', 'Donate', 'Donkey', 'Donor', 'Door', 'Dose', 'Double', 'Dove', 'Draft', 'Dragon', 'Drama', 'Drastic', 'Draw', 'Dream', 'Dress', 'Drift', 'Drill', 'Drink', 'Drip', 'Drive', 'Drop', 'Drum', 'Dry', 'Duck', 'Dumb', 'Dune', 'During', 'Dust', 'Dutch', 'Duty', 'Dwarf', 'Dynamic', 'Eager', 'Eagle', 'Early', 'Earn', 'Earth', 'Easily', 'East', 'Easy', 'Echo', 'Ecology', 'Economy', 'Edge', 'Edit', 'Educate', 'Effort', 'Egg', 'Eight', 'Either', 'Elbow', 'Elder', 'Electric', 'Elegant', 'Element', 'Elephant', 'Elevator', 'Elite', 'Else', 'Embark', 'Embody', 'Embrace', 'Emerge', 'Emotion', 'Employ', 'Empower', 'Empty', 'Enable', 'Enact', 'End', 'Endless', 'Endorse', 'Enemy', 'Energy', 'Enforce', 'Engage', 'Engine', 'Enhance', 'Enjoy', 'Enlist', 'Enough', 'Enrich', 'Enroll', 'Ensure', 'Enter', 'Entire', 'Entry', 'Envelope', 'Episode', 'Equal', 'Equip', 'Era', 'Erase', 'Erode', 'Erosion', 'Error', 'Erupt', 'Escape', 'Essay', 'Essence', 'Estate', 'Eternal', 'Ethics', 'Evidence', 'Evil', 'Evoke', 'Evolve', 'Exact', 'Example', 'Excess', 'Exchange', 'Excite', 'Exclude', 'Excuse', 'Execute', 'Exercise', 'Exhaust', 'Exhibit', 'Exile', 'Exist', 'Exit', 'Exotic', 'Expand', 'Expect', 'Expire', 'Explain', 'Expose', 'Express', 'Extend', 'Extra', 'Eye', 'Eyebrow', 'Fabric', 'Face', 'Faculty', 'Fade', 'Faint', 'Faith', 'Fall', 'False', 'Fame', 'Family', 'Famous', 'Fan', 'Fancy', 'Fantasy', 'Farm', 'Fashion', 'Fat', 'Fatal', 'Father', 'Fatigue', 'Fault', 'Favorite', 'Feature', 'February', 'Federal', 'Fee', 'Feed', 'Feel', 'Female', 'Fence', 'Festival', 'Fetch', 'Fever', 'Few', 'Fiber', 'Fiction', 'Field', 'Figure', 'File', 'Film', 'Filter', 'Final', 'Find', 'Fine', 'Finger', 'Finish', 'Fire', 'Firm', 'First', 'Fiscal', 'Fish', 'Fit', 'Fitness', 'Fix', 'Flag', 'Flame', 'Flash', 'Flat', 'Flavor', 'Flee', 'Flight', 'Flip', 'Float', 'Flock', 'Floor', 'Flower', 'Fluid', 'Flush', 'Fly', 'Foam', 'Focus', 'Fog', 'Foil', 'Fold', 'Follow', 'Food', 'Foot', 'Force', 'Forest', 'Forget', 'Fork', 'Fortune', 'Forum', 'Forward', 'Fossil', 'Foster', 'Found', 'Fox', 'Fragile', 'Frame', 'Frequent', 'Fresh', 'Friend', 'Fringe', 'Frog', 'Front', 'Frost', 'Frown', 'Frozen', 'Fruit', 'Fuel', 'Fun', 'Funny', 'Furnace', 'Fury', 'Future', 'Gadget', 'Gain', 'Galaxy', 'Gallery', 'Game', 'Gap', 'Garage', 'Garbage', 'Garden', 'Garlic', 'Garment', 'Gas', 'Gasp', 'Gate', 'Gather', 'Gauge', 'Gaze', 'General', 'Genius', 'Genre', 'Gentle', 'Genuine', 'Gesture', 'Ghost', 'Giant', 'Gift', 'Giggle', 'Ginger', 'Giraffe', 'Girl', 'Give', 'Glad', 'Glance', 'Glare', 'Glass', 'Glide', 'Glimpse', 'Globe', 'Gloom', 'Glory', 'Glove', 'Glow', 'Glue', 'Goat', 'Goddess', 'Gold', 'Good', 'Goose', 'Gorilla', 'Gospel', 'Gossip', 'Govern', 'Gown', 'Grab', 'Grace', 'Grain', 'Grant', 'Grape', 'Grass', 'Gravity', 'Great', 'Green', 'Grid', 'Grief', 'Grit', 'Grocery', 'Group', 'Grow', 'Grunt', 'Guard', 'Guess', 'Guide', 'Guilt', 'Guitar', 'Gun', 'Gym', 'Habit', 'Hair', 'Half', 'Hammer', 'Hamster', 'Hand', 'Happy', 'Harbor', 'Hard', 'Harsh', 'Harvest', 'Hat', 'Have', 'Hawk', 'Hazard', 'Head', 'Health', 'Heart', 'Heavy', 'Hedgehog', 'Height', 'Hello', 'Helmet', 'Help', 'Hen', 'Hero', 'Hidden', 'High', 'Hill', 'Hint', 'Hip', 'Hire', 'History', 'Hobby', 'Hockey', 'Hold', 'Hole', 'Holiday', 'Hollow', 'Home', 'Honey', 'Hood', 'Hope', 'Horn', 'Horror', 'Horse', 'Hospital', 'Host', 'Hotel', 'Hour', 'Hover', 'Hub', 'Huge', 'Human', 'Humble', 'Humor', 'Hundred', 'Hungry', 'Hunt', 'Hurdle', 'Hurry', 'Hurt', 'Husband', 'Hybrid', 'Ice', 'Icon', 'Idea', 'Identify', 'Idle', 'Ignore', 'Ill', 'Illegal', 'Illness', 'Image', 'Imitate', 'Immense', 'Immune', 'Impact', 'Impose', 'Improve', 'Impulse', 'Inch', 'Include', 'Income', 'Increase', 'Index', 'Indicate', 'Indoor', 'Industry', 'Infant', 'Inflict', 'Inform', 'Inhale', 'Inherit', 'Initial', 'Inject', 'Injury', 'Inmate', 'Inner', 'Innocent', 'Input', 'Inquiry', 'Insane', 'Insect', 'Inside', 'Inspire', 'Install', 'Intact', 'Interest', 'Into', 'Invest', 'Invite', 'Involve', 'Iron', 'Island', 'Isolate', 'Issue', 'Item', 'Ivory', 'Jacket', 'Jaguar', 'Jar', 'Jazz', 'Jealous', 'Jeans', 'Jelly', 'Jewel', 'Job', 'Join', 'Joke', 'Journey', 'Joy', 'Judge', 'Juice', 'Jump', 'Jungle', 'Junior', 'Junk', 'Just', 'Kangaroo', 'Keen', 'Keep', 'Ketchup', 'Key', 'Kick', 'Kid', 'Kidney', 'Kind', 'Kingdom', 'Kiss', 'Kit', 'Kitchen', 'Kite', 'Kitten', 'Kiwi', 'Knee', 'Knife', 'Knock', 'Know', 'Lab', 'Label', 'Labor', 'Ladder', 'Lady', 'Lake', 'Lamp', 'Language', 'Laptop', 'Large', 'Later', 'Latin', 'Laugh', 'Laundry', 'Lava', 'Law', 'Lawn', 'Lawsuit', 'Layer', 'Lazy', 'Leader', 'Leaf', 'Learn', 'Leave', 'Lecture', 'Left', 'Leg', 'Legal', 'Legend', 'Leisure', 'Lemon', 'Lend', 'Length', 'Lens', 'Leopard', 'Lesson', 'Letter', 'Level', 'Liar', 'Liberty', 'Library', 'License', 'Life', 'Lift', 'Light', 'Like', 'Limb', 'Limit', 'Link', 'Lion', 'Liquid', 'List', 'Little', 'Live', 'Lizard', 'Load', 'Loan', 'Lobster', 'Local', 'Lock', 'Logic', 'Lonely', 'Long', 'Loop', 'Lottery', 'Loud', 'Lounge', 'Love', 'Loyal', 'Lucky', 'Luggage', 'Lumber', 'Lunar', 'Lunch', 'Luxury', 'Lyrics', 'Machine', 'Mad', 'Magic', 'Magnet', 'Maid', 'Mail', 'Main', 'Major', 'Make', 'Mammal', 'Man', 'Manage', 'Mandate', 'Mango', 'Mansion', 'Manual', 'Maple', 'Marble', 'March', 'Margin', 'Marine', 'Market', 'Marriage', 'Mask', 'Mass', 'Master', 'Match', 'Material', 'Math', 'Matrix', 'Matter', 'Maximum', 'Maze', 'Meadow', 'Mean', 'Measure', 'Meat', 'Mechanic', 'Medal', 'Media', 'Melody', 'Melt', 'Member', 'Memory', 'Mention', 'Menu', 'Mercy', 'Merge', 'Merit', 'Merry', 'Mesh', 'Message', 'Metal', 'Method', 'Middle', 'Midnight', 'Milk', 'Million', 'Mimic', 'Mind', 'Minimum', 'Minor', 'Minute', 'Miracle', 'Mirror', 'Misery', 'Miss', 'Mistake', 'Mix', 'Mixed', 'Mixture', 'Mobile', 'Model', 'Modify', 'Mom', 'Moment', 'Monitor', 'Monkey', 'Monster', 'Month', 'Moon', 'Moral', 'More', 'Morning', 'Mosquito', 'Mother', 'Motion', 'Motor', 'Mountain', 'Mouse', 'Move', 'Movie', 'Much', 'Muffin', 'Mule', 'Multiply', 'Muscle', 'Museum', 'Mushroom', 'Music', 'Must', 'Mutual', 'Myself', 'Mystery', 'Myth', 'Naive', 'Name', 'Napkin', 'Narrow', 'Nasty', 'Nation', 'Nature', 'Near', 'Neck', 'Need', 'Negative', 'Neglect', 'Neither', 'Nephew', 'Nerve', 'Nest', 'Net', 'Network', 'Neutral', 'Never', 'News', 'Next', 'Nice', 'Night', 'Noble', 'Noise', 'Nominee', 'Noodle', 'Normal', 'North', 'Nose', 'Notable', 'Note', 'Nothing', 'Notice', 'Novel', 'Now', 'Nuclear', 'Number', 'Nurse', 'Nut', 'Oak', 'Obey', 'Object', 'Oblige', 'Obscure', 'Observe', 'Obtain', 'Obvious', 'Occur', 'Ocean', 'October', 'Odor', 'Off', 'Offer', 'Office', 'Often', 'Oil', 'Okay', 'Old', 'Olive', 'Olympic', 'Omit', 'Once', 'One', 'Onion', 'Online', 'Only', 'Open', 'Opera', 'Opinion', 'Oppose', 'Option', 'Orange', 'Orbit', 'Orchard', 'Order', 'Ordinary', 'Organ', 'Orient', 'Original', 'Orphan', 'Ostrich', 'Other', 'Outdoor', 'Outer', 'Output', 'Outside', 'Oval', 'Oven', 'Over', 'Own', 'Owner', 'Oxygen', 'Oyster', 'Ozone', 'Pact', 'Paddle', 'Page', 'Pair', 'Palace', 'Palm', 'Panda', 'Panel', 'Panic', 'Panther', 'Paper', 'Parade', 'Parent', 'Park', 'Parrot', 'Party', 'Pass', 'Patch', 'Path', 'Patient', 'Patrol', 'Pattern', 'Pause', 'Pave', 'Payment', 'Peace', 'Peanut', 'Pear', 'Peasant', 'Pelican', 'Pen', 'Penalty', 'Pencil', 'People', 'Pepper', 'Perfect', 'Permit', 'Person', 'Pet', 'Phone', 'Photo', 'Phrase', 'Physical', 'Piano', 'Picnic', 'Picture', 'Piece', 'Pig', 'Pigeon', 'Pill', 'Pilot', 'Pink', 'Pioneer', 'Pipe', 'Pistol', 'Pitch', 'Pizza', 'Place', 'Planet', 'Plastic', 'Plate', 'Play', 'Please', 'Pledge', 'Pluck', 'Plug', 'Plunge', 'Poem', 'Poet', 'Point', 'Polar', 'Pole', 'Police', 'Pond', 'Pony', 'Pool', 'Popular', 'Portion', 'Position', 'Possible', 'Post', 'Potato', 'Pottery', 'Poverty', 'Powder', 'Power', 'Practice', 'Praise', 'Predict', 'Prefer', 'Prepare', 'Present', 'Pretty', 'Prevent', 'Price', 'Pride', 'Primary', 'Print', 'Priority', 'Prison', 'Private', 'Prize', 'Problem', 'Process', 'Produce', 'Profit', 'Program', 'Project', 'Promote', 'Proof', 'Property', 'Prosper', 'Protect', 'Proud', 'Provide', 'Public', 'Pudding', 'Pull', 'Pulp', 'Pulse', 'Pumpkin', 'Punch', 'Pupil', 'Puppy', 'Purchase', 'Purity', 'Purpose', 'Purse', 'Push', 'Put', 'Puzzle', 'Pyramid', 'Quality', 'Quantum', 'Quarter', 'Question', 'Quick', 'Quit', 'Quiz', 'Quote', 'Rabbit', 'Raccoon', 'Race', 'Rack', 'Radar', 'Radio', 'Rail', 'Rain', 'Raise', 'Rally', 'Ramp', 'Ranch', 'Random', 'Range', 'Rapid', 'Rare', 'Rate', 'Rather', 'Raven', 'Raw', 'Razor', 'Ready', 'Real', 'Reason', 'Rebel', 'Rebuild', 'Recall', 'Receive', 'Recipe', 'Record', 'Recycle', 'Reduce', 'Reflect', 'Reform', 'Refuse', 'Region', 'Regret', 'Regular', 'Reject', 'Relax', 'Release', 'Relief', 'Rely', 'Remain', 'Remember', 'Remind', 'Remove', 'Render', 'Renew', 'Rent', 'Reopen', 'Repair', 'Repeat', 'Replace', 'Report', 'Require', 'Rescue', 'Resemble', 'Resist', 'Resource', 'Response', 'Result', 'Retire', 'Retreat', 'Return', 'Reunion', 'Reveal', 'Review', 'Reward', 'Rhythm', 'Rib', 'Ribbon', 'Rice', 'Rich', 'Ride', 'Ridge', 'Rifle', 'Right', 'Rigid', 'Ring', 'Riot', 'Ripple', 'Risk', 'Ritual', 'Rival', 'River', 'Road', 'Roast', 'Robot', 'Robust', 'Rocket', 'Romance', 'Roof', 'Rookie', 'Room', 'Rose', 'Rotate', 'Rough', 'Round', 'Route', 'Royal', 'Rubber', 'Rude', 'Rug', 'Rule', 'Run', 'Runway', 'Rural', 'Sad', 'Saddle', 'Sadness', 'Safe', 'Sail', 'Salad', 'Salmon', 'Salon', 'Salt', 'Salute', 'Same', 'Sample', 'Sand', 'Satisfy', 'Satoshi', 'Sauce', 'Sausage', 'Save', 'Say', 'Scale', 'Scan', 'Scare', 'Scatter', 'Scene', 'Scheme', 'School', 'Science', 'Scissors', 'Scorpion', 'Scout', 'Scrap', 'Screen', 'Script', 'Scrub', 'Sea', 'Search', 'Season', 'Seat', 'Second', 'Secret', 'Section', 'Security', 'Seed', 'Seek', 'Segment', 'Select', 'Sell', 'Seminar', 'Senior', 'Sense', 'Sentence', 'Series', 'Service', 'Session', 'Settle', 'Setup', 'Seven', 'Shadow', 'Shaft', 'Shallow', 'Share', 'Shed', 'Shell', 'Sheriff', 'Shield', 'Shift', 'Shine', 'Ship', 'Shiver', 'Shock', 'Shoe', 'Shoot', 'Shop', 'Short', 'Shoulder', 'Shove', 'Shrimp', 'Shrug', 'Shuffle', 'Shy', 'Sibling', 'Sick', 'Side', 'Siege', 'Sight', 'Sign', 'Silent', 'Silk', 'Silly', 'Silver', 'Similar', 'Simple', 'Since', 'Sing', 'Siren', 'Sister', 'Situate', 'Six', 'Size', 'Skate', 'Sketch', 'Ski', 'Skill', 'Skin', 'Skirt', 'Skull', 'Slab', 'Slam', 'Sleep', 'Slender', 'Slice', 'Slide', 'Slight', 'Slim', 'Slogan', 'Slot', 'Slow', 'Slush', 'Small', 'Smart', 'Smile', 'Smoke', 'Smooth', 'Snack', 'Snake', 'Snap', 'Sniff', 'Snow', 'Soap', 'Soccer', 'Social', 'Sock', 'Soda', 'Soft', 'Solar', 'Soldier', 'Solid', 'Solution', 'Solve', 'Someone', 'Song', 'Soon', 'Sorry', 'Sort', 'Soul', 'Sound', 'Soup', 'Source', 'South', 'Space', 'Spare', 'Spatial', 'Spawn', 'Speak', 'Special', 'Speed', 'Spell', 'Spend', 'Sphere', 'Spice', 'Spider', 'Spike', 'Spin', 'Spirit', 'Split', 'Spoil', 'Sponsor', 'Spoon', 'Sport', 'Spot', 'Spray', 'Spread', 'Spring', 'Spy', 'Square', 'Squeeze', 'Squirrel', 'Stable', 'Stadium', 'Staff', 'Stage', 'Stairs', 'Stamp', 'Stand', 'Start', 'State', 'Stay', 'Steak', 'Steel', 'Stem', 'Step', 'Stereo', 'Stick', 'Still', 'Sting', 'Stock', 'Stomach', 'Stone', 'Stool', 'Story', 'Stove', 'Strategy', 'Street', 'Strike', 'Strong', 'Struggle', 'Student', 'Stuff', 'Stumble', 'Style', 'Subject', 'Submit', 'Subway', 'Success', 'Such', 'Sudden', 'Suffer', 'Sugar', 'Suggest', 'Suit', 'Summer', 'Sun', 'Sunny', 'Sunset', 'Super', 'Supply', 'Supreme', 'Sure', 'Surface', 'Surge', 'Surprise', 'Surround', 'Survey', 'Suspect', 'Sustain', 'Swallow', 'Swamp', 'Swap', 'Swarm', 'Swear', 'Sweet', 'Swift', 'Swim', 'Swing', 'Switch', 'Sword', 'Symbol', 'Symptom', 'Syrup', 'System', 'Table', 'Tackle', 'Tag', 'Tail', 'Talent', 'Talk', 'Tank', 'Tape', 'Target', 'Task', 'Taste', 'Tattoo', 'Taxi', 'Teach', 'Team', 'Tell', 'Ten', 'Tenant', 'Tennis', 'Tent', 'Term', 'Test', 'Text', 'Thank', 'That', 'Theme', 'Then', 'Theory', 'There', 'They', 'Thing', 'This', 'Thought', 'Three', 'Thrive', 'Throw', 'Thumb', 'Thunder', 'Ticket', 'Tide', 'Tiger', 'Tilt', 'Timber', 'Time', 'Tiny', 'Tip', 'Tired', 'Tissue', 'Title', 'Toast', 'Tobacco', 'Today', 'Toddler', 'Toe', 'Together', 'Toilet', 'Token', 'Tomato', 'Tomorrow', 'Tone', 'Tongue', 'Tonight', 'Tool', 'Tooth', 'Top', 'Topic', 'Topple', 'Torch', 'Tornado', 'Tortoise', 'Toss', 'Total', 'Tourist', 'Toward', 'Tower', 'Town', 'Toy', 'Track', 'Trade', 'Traffic', 'Tragic', 'Train', 'Transfer', 'Trap', 'Trash', 'Travel', 'Tray', 'Treat', 'Tree', 'Trend', 'Trial', 'Tribe', 'Trick', 'Trigger', 'Trim', 'Trip', 'Trophy', 'Trouble', 'Truck', 'True', 'Truly', 'Trumpet', 'Trust', 'Truth', 'Try', 'Tube', 'Tuition', 'Tumble', 'Tuna', 'Tunnel', 'Turkey', 'Turn', 'Turtle', 'Twelve', 'Twenty', 'Twice', 'Twin', 'Twist', 'Two', 'Type', 'Typical', 'Ugly', 'Umbrella', 'Unable', 'Unaware', 'Uncle', 'Uncover', 'Under', 'Undo', 'Unfair', 'Unfold', 'Unhappy', 'Uniform', 'Unique', 'Unit', 'Universe', 'Unknown', 'Unlock', 'Until', 'Unusual', 'Unveil', 'Update', 'Upgrade', 'Uphold', 'Upon', 'Upper', 'Upset', 'Urban', 'Urge', 'Usage', 'Use', 'Used', 'Useful', 'Useless', 'Usual', 'Utility', 'Vacant', 'Vacuum', 'Vague', 'Valid', 'Valley', 'Valve', 'Van', 'Vanish', 'Vapor', 'Various', 'Vast', 'Vault', 'Vehicle', 'Velvet', 'Vendor', 'Venture', 'Venue', 'Verb', 'Verify', 'Version', 'Very', 'Vessel', 'Veteran', 'Viable', 'Vibrant', 'Vicious', 'Victory', 'Video', 'View', 'Village', 'Vintage', 'Violin', 'Virtual', 'Virus', 'Visa', 'Visit', 'Visual', 'Vital', 'Vivid', 'Vocal', 'Voice', 'Void', 'Volcano', 'Volume', 'Vote', 'Voyage', 'Wage', 'Wagon', 'Wait', 'Walk', 'Wall', 'Walnut', 'Want', 'Warfare', 'Warm', 'Warrior', 'Wash', 'Wasp', 'Waste', 'Water', 'Wave', 'Way', 'Wealth', 'Weapon', 'Wear', 'Weasel', 'Weather', 'Web', 'Wedding', 'Weekend', 'Weird', 'Welcome', 'West', 'Wet', 'Whale', 'What', 'Wheat', 'Wheel', 'When', 'Where', 'Whip', 'Whisper', 'Wide', 'Width', 'Wife', 'Wild', 'Will', 'Win', 'Window', 'Wine', 'Wing', 'Wink', 'Winner', 'Winter', 'Wire', 'Wisdom', 'Wise', 'Wish', 'Witness', 'Wolf', 'Woman', 'Wonder', 'Wood', 'Wool', 'Word', 'Work', 'World', 'Worry', 'Worth', 'Wrap', 'Wreck', 'Wrestle', 'Wrist', 'Write', 'Wrong', 'Yard', 'Year', 'Yellow', 'You', 'Young', 'Youth', 'Zebra', 'Zero', 'Zone', 'Zoo']

//List curated by Yamamoto san
export const wordsList = [ '怪我',
'名刺',
'桃',
'野菜',
'電池',
'弟',
'言葉',
'筆箱',
'仲間',
'缶',
'意志',
'新聞',
'机',
'空気',
'手',
'土地',
'寺',
'神社',
'光',
'弟子',
'師匠',
'家',
'絵',
'動物',
'母',
'世界',
'鹿',
'地球',
'父',
'仕事',
'鉄道',
'男',
'老人',
'名前',
'食堂',
'雑誌',
'手帳',
'時計',
'傘',
'鍵',
'野球',
'道',
'映画',
'桜',
'水',
'封筒',
'地図',
'国',
'社長',
'学校',
'研究',
'植物',
'食品',
'太陽',
'課長',
'目',
'街',
'農場',
'物語',
'海',
'磁石',
'眼鏡',
'夜',
'生活',
'葬式',
'北',
'科学',
'部屋',
'友人',
'魚',
'山',
'交番',
'小説',
'馬',
'顔',
'木材',
'信号',
'白',
'結婚',
'紙',
'音楽',
'人形',
'手紙',
'川',
'介護',
'成績',
'食器',
'赤',
'鳥',
'犬',
'家族',
'歌',
'博士',
'作家',
'黒',
'旅館',
'風',
'歌手',
'船',
'本棚',
'岩',
'火災',
'南',
'家賃',
'作品',
'合格',
'建物',
'布団',
'王',
'皇帝',
'相撲',
'島',
'足',
'記録',
'機械',
'風呂',
'床屋',
'熱',
'雪',
'東',
'高校',
'町',
'罰金',
'鉛',
'大学',
'図',
'会議',
'週',
'緑',
'季節',
'時間',
'心',
'紅葉',
'寿司',
'鍋',
'西',
'地面',
'港',
'小麦',
'工場',
'旅行',
'朝',
'津波',
'生徒',
'地震',
'人',
'道路',
'雨',
'泥棒',
'声',
'兄',
'卵',
'広場',
'武器',
'軍隊',
'爆弾',
'経費',
'職員',
'波',
'選挙',
'帆',
'材料',
'分数',
'森',
'窓',
'店',
'夏',
'列車',
'壁',
'希望',
'空',
'冬',
'土',
'楽器',
'展示',
'草',
'乳牛',
'看板',
'移民',
'過去',
'天候',
'月',
'捜査',
'花',
'旅',
'裁判',
'口',
'勝利',
'革命',
'庭',
'上昇',
'打撃',
'血',
'個性',
'銀行',
'独占',
'指示',
'耳',
'息子',
'湖',
'幻想',
'春',
'剣道',
'国家',
'辞書',
'刀',
'石',
'実験',
'鉄',
'笑顔',
'穴',
'村',
'大会',
'金属',
'茶色',
'猫',
'髪',
'床',
'結果',
'丘',
'金庫',
'温泉',
'法則',
'海岸',
'砂',
'土壌',
'温度',
'指',
'業界',
'果物',
'感覚',
'首都',
'椅子',
'危険',
'兵士',
'練習',
'憲法',
'医師',
'正午',
'作物',
'会計',
'学生',
'昆虫',
'授業',
'人間',
'歴史',
'鏡',
'骨',
'女',
'日記',
'隣人',
'群衆',
'詩',
'鐘',
'肉',
'恐怖',
'視力',
'惑星',
'地雷',
'検索',
'保険',
'黄色',
'銃',
'印刷',
'砂漠',
'親',
'留学',
'物質',
'豚',
'脂肪',
'駅',
'充電',
'市場',
'漢字',
'敵',
'返事',
'自然',
'液体',
'意味',
'荷物',
'電話',
'首',
'酸素',
'砂糖',
'死',
'正解',
'銀',
'感謝',
'姉妹',
'経験',
'英語',
'夢',
'試験',
'合計',
'基本',
'谷',
'座席',
'帽子',
'成功',
'会社',
'契約',
'地下',
'妻',
'靴',
'肩',
'綿',
'財産',
'分子',
'塩',
'鼻',
'美術',
'請求',
'大陸' ]

export const originalList = ['ように',
'私は',
'彼の',
'その',
'彼',
'た',
'ために',
'上の',
'アール',
'とともに',
'彼ら',
'ある',
'アット',
'一つ',
'持っている',
'この',
'から',
'バイ',
'ホット',
'言葉',
'しかし',
'何',
'いくつかの',
'です',
'それ',
'あなた',
'または',
'持っていた',
'インクルード',
'の',
'へ',
'そして',
'は',
'で',
'我々',
'缶',
'アウト',
'その他',
'だった',
'これ',
'やる',
'それらの',
'時間',
'もし',
'意志',
'方法',
'前記',
'の',
'それぞれ',
'言う',
'し',
'セット',
'個',
'欲しい',
'空気',
'よく',
'また',
'遊ぶ',
'小さい',
'終わり',
'置く',
'ホーム',
'読む',
'手',
'ポート',
'大きい',
'スペル',
'加える',
'さらに',
'土地',
'ここに',
'しなければ',
'大きい',
'高い',
'そのような',
'続く',
'行為',
'なぜ',
'頼む',
'人々',
'変更',
'行ってきます',
'光',
'種類',
'オフ',
'必要',
'家',
'絵',
'試す',
'私たち',
'再び',
'動物',
'ポイント',
'母',
'世界',
'近く',
'ビルド',
'自己',
'地球',
'父',
'任意の',
'新しい',
'仕事',
'パート',
'取る',
'ゲット',
'場所',
'製',
'暮らす',
'どこ',
'後に',
'バック',
'少し',
'唯一の',
'ラウンド',
'男',
'年',
'来た',
'ショー',
'すべての',
'良い',
'私に',
'与える',
'私たちの',
'下',
'名前',
'非常に',
'スルー',
'ただ',
'フォーム',
'文',
'素晴らしい',
'思う',
'言う',
'助け',
'低い',
'ライン',
'異なる',
'ターン',
'原因',
'ずっと',
'意味する',
'前に',
'移動',
'権利',
'男の子',
'古い',
'あまりに',
'同じ',
'彼女',
'すべて',
'そこ',
'時',
'アップ',
'使用',
'あなたの',
'道',
'約',
'多くの',
'その後',
'それら',
'書く',
'でしょう',
'ような',
'そう',
'これらの',
'彼女の',
'長い',
'作る',
'もの',
'見る',
'彼に',
'二つ',
'があります',
'見える',
'多くの',
'日',
'可能性',
'行く',
'来る',
'やった',
'番号',
'聞こえる',
'いいえ',
'最も',
'人々',
'私の',
'オーバー',
'知っている',
'水',
'比べて',
'コール',
'最初の',
'誰',
'よい',
'ダウン',
'サイド',
'き',
'今',
'見つける',
'ヘッド',
'スタンド',
'独自の',
'ページ',
'べき',
'国',
'発見',
'答え',
'学校',
'成長する',
'研究',
'まだ',
'学ぶ',
'植物',
'カバー',
'食品',
'太陽',
'つの',
'間に',
'状態',
'キープ',
'目',
'ネバー',
'最後の',
'てみましょう',
'考え',
'街',
'ツリー',
'クロス',
'農場',
'ハード',
'スタート',
'可能性がある',
'物語',
'のこぎり',
'遠く',
'海',
'描く',
'左',
'遅く',
'ラン',
'ない',
'一方',
'プレス',
'クローズ',
'夜',
'リアル',
'生活',
'少数',
'北',
'ブック',
'運ぶ',
'かかった',
'科学',
'食べる',
'部屋',
'友人',
'始まった',
'アイデア',
'魚',
'山',
'停止',
'一度',
'ベース',
'聞く',
'馬',
'カット',
'確か',
'見る',
'カラー',
'顔',
'木材',
'メイン',
'オープン',
'見える',
'一緒に',
'次',
'白',
'子どもたち',
'始まる',
'だ',
'歩く',
'例',
'和らげる',
'紙',
'グループ',
'常に',
'音楽',
'それらの',
'両方',
'マーク',
'しばしば',
'手紙',
'まで',
'マイル',
'川',
'カー',
'フィート',
'介護',
'第2',
'十分な',
'平野',
'女の子',
'いつもの',
'若い',
'レディー',
'上記',
'今までに',
'赤',
'リスト',
'しかし',
'感じる',
'トーク',
'鳥',
'すぐに',
'ボディ',
'犬',
'家族',
'ダイレクト',
'ポーズ',
'去る',
'歌',
'測定',
'ドア',
'製品',
'黒',
'短い',
'数字',
'クラス',
'風',
'質問',
'起こる',
'完全な',
'船',
'エリア',
'半分',
'岩',
'オーダー',
'火災',
'南',
'問題',
'作品',
'言われ',
'知っていた',
'合格',
'以来',
'トップ',
'全体',
'王',
'ストリート',
'インチ',
'掛ける',
'何も',
'もちろん',
'滞在',
'ホイール',
'フル',
'力',
'ブルー',
'オブジェクト',
'決定する',
'表面',
'深い',
'ムーン',
'島',
'足',
'システム',
'忙しい',
'テスト',
'記録',
'ボート',
'一般的な',
'ゴールド',
'可能',
'飛行機',
'代わり',
'ドライ',
'不思議',
'笑い',
'千の',
'前',
'走った',
'チェック',
'ゲーム',
'形状',
'一致する',
'ホット',
'ミス',
'た',
'熱',
'雪',
'タイヤ',
'持って来る',
'はい',
'遠い',
'埋める',
'東',
'ペイント',
'言語',
'の間で',
'ユニット',
'パワー',
'町',
'罰金',
'特定の',
'飛ぶ',
'落ちる',
'鉛',
'泣く',
'暗い',
'マシン',
'ノート',
'待つ',
'計画',
'図',
'スター',
'ボックス',
'名詞',
'フィールド',
'残り',
'正しい',
'できる',
'ポンド',
'終わった',
'美しさ',
'ドライブ',
'立っていた',
'含む',
'フロント',
'教える',
'週',
'ファイナル',
'与えた',
'緑',
'ああ',
'クイック',
'開発する',
'海',
'暖かい',
'無料で',
'分',
'強い',
'特別',
'心',
'背後に',
'明確な',
'テール',
'作る',
'事実',
'スペース',
'聞いた',
'ベスト',
'時間',
'良い',
'真の',
'間に',
'百',
'五',
'覚えている',
'ステップ',
'早い',
'ホールド',
'西',
'地面',
'関心',
'リーチ',
'速い',
'動詞',
'歌う',
'聞く',
'六',
'テーブル',
'旅行',
'レス',
'朝',
'十',
'シンプル',
'いくつかの',
'母音',
'の方へ',
'戦争',
'産む',
'に対する',
'パターン',
'遅い',
'センター',
'愛',
'人',
'マネー',
'サーブ',
'見える',
'道路',
'マップ',
'雨',
'ルール',
'支配する',
'引っ張る',
'寒い',
'予告',
'声',
'エネルギー',
'狩り',
'ありそうな',
'ベッド',
'兄',
'卵',
'乗る',
'セル',
'信じる',
'たぶん',
'選ぶ',
'突然の',
'カウント',
'広場',
'理由',
'長さ',
'表す',
'アート',
'テーマ',
'地域',
'サイズ',
'変える',
'落ち着く',
'話す',
'重さ',
'一般',
'アイス',
'問題',
'サークル',
'ペア',
'含める',
'分割',
'音節',
'フェルト',
'壮大な',
'ボール',
'まだ',
'波',
'ドロップ',
'心',
'現在',
'重い',
'ダンス',
'エンジン',
'ポジション',
'アーム',
'広い',
'帆',
'材料',
'分数',
'森',
'座る',
'レース',
'窓',
'店',
'夏',
'列車',
'スリープ',
'証明する',
'ローン',
'レッグ',
'エクササイズ',
'壁',
'キャッチ',
'マウント',
'希望',
'空',
'ボード',
'喜び',
'冬',
'土',
'書かれた',
'ワイルド',
'楽器',
'保管',
'ガラス',
'草',
'乳牛',
'仕事',
'エッジ',
'看板',
'訪問',
'過去',
'ソフト',
'楽しい',
'明るい',
'ガス',
'天候',
'月',
'万',
'クマ',
'仕上げ',
'幸せな',
'希望',
'花',
'衣服を着せる',
'奇妙な',
'いなくなった',
'トレード',
'メロディー',
'旅',
'オフィス',
'受け取る',
'行',
'口',
'正確な',
'シンボル',
'死ぬ',
'最低',
'トラブル',
'シャウト',
'ただし',
'書いた',
'シード',
'トーン',
'参加する',
'提案する',
'クリーン',
'ブレーク',
'女性',
'庭',
'上昇',
'悪い',
'打撃',
'オイル',
'血',
'触れる',
'成長した',
'セント',
'ミックス',
'チーム',
'ワイヤー',
'コスト',
'失われた',
'ブラウン',
'着用',
'庭',
'等しい',
'送信された',
'選ぶ',
'落ちた',
'フィット',
'流れ',
'フェア',
'銀行',
'集める',
'保存',
'コントロール',
'進',
'耳',
'ほかに',
'かなり',
'壊した',
'ケース',
'ミドル',
'殺す',
'息子',
'湖',
'瞬間',
'スケール',
'騒々しい',
'春',
'観察する',
'子ども',
'ストレート',
'子音',
'国家',
'辞書',
'ミルク',
'スピード',
'方法',
'オルガン',
'支払い',
'年齢',
'セクション',
'ドレス',
'クラウド',
'驚き',
'静かな',
'石',
'小さな',
'登る',
'涼しい',
'デザイン',
'貧しい',
'たくさん',
'実験',
'ボトム',
'キー',
'鉄',
'シングル',
'スティック',
'フラット',
'個の',
'スキン',
'笑顔',
'しわ',
'穴',
'ジャンプ',
'赤ちゃん',
'人',
'村',
'大会',
'ルート',
'買う',
'上げる',
'解く',
'金属',
'かどうか',
'プッシュ',
'パラグラフ',
'第一',
'猫',
'ハンドヘルド',
'髪',
'説明する',
'料理人',
'床',
'どちら',
'結果',
'燃やす',
'丘',
'金庫',
'猫',
'世紀',
'考える',
'タイプ',
'法則',
'ビット',
'海岸',
'コピー',
'フレーズ',
'サイレント',
'背の高い',
'砂',
'土壌',
'ロール',
'温度',
'指',
'業界',
'値',
'戦い',
'うそ',
'ビート',
'エキサイト',
'ナチュラル',
'ビュー',
'感覚',
'首都',
'ないでしょう',
'椅子',
'危険',
'フルーツ',
'金持ち',
'厚い',
'兵士',
'プロセス',
'操作する',
'練習',
'別',
'難しい',
'医師',
'どうぞ',
'守る',
'正午',
'作物',
'モダン',
'要素',
'ヒット',
'学生',
'コーナー',
'パーティー',
'サプライ',
'その',
'検索する',
'リング',
'キャラクター',
'昆虫',
'キャッチ',
'期間',
'示す',
'ラジオ',
'スポーク',
'アトム',
'人間',
'歴史',
'効果',
'犬',
'期待する',
'骨',
'レール',
'想像する',
'提供する',
'同意する',
'このように',
'優しい',
'女',
'キャプテン',
'推測',
'必要',
'シャープ',
'ウイング',
'作る',
'隣人',
'ウォッシュ',
'バット',
'むしろ',
'群衆',
'トウモロコシ',
'比較する',
'詩',
'文字列',
'鐘',
'決まる',
'肉',
'こする',
'チューブ',
'有名な',
'ドル',
'ストリーム',
'恐怖',
'視力',
'薄い',
'三角形',
'惑星',
'急ぐ',
'チーフ',
'コロニー',
'クロック',
'地雷',
'ネクタイ',
'入力する',
'主要な',
'新鮮な',
'検索',
'送信',
'黄色',
'銃',
'許可する',
'印刷',
'死んだ',
'スポット',
'砂漠',
'スーツ',
'現在の',
'リフト',
'ローズ',
'届く',
'マスター',
'トラック',
'親',
'海岸',
'分裂',
'シート',
'物質',
'好む',
'接続する',
'ポスト',
'過ごす',
'和音',
'脂肪',
'うれしい',
'オリジナル',
'シェア',
'駅',
'お父さん',
'パン',
'充電',
'適切な',
'バー',
'申し出',
'セグメント',
'スレーブ',
'アヒル',
'インスタント',
'市場',
'度',
'投入する',
'ひよこ',
'かわいい',
'敵',
'返事',
'ドリンク',
'起こる',
'サポート',
'スピーチ',
'自然',
'レンジ',
'スチーム',
'モーション',
'パス',
'液体',
'ログ',
'意味',
'商',
'歯牙',
'シェル',
'首',
'酸素',
'砂糖',
'死',
'かわいい',
'スキル',
'女性たち',
'シーズン',
'正解',
'マグネット',
'銀',
'感謝',
'ブランチ',
'マッチ',
'サフィックス',
'特に',
'イチジク',
'恐れて',
'巨大な',
'姉妹',
'スチール',
'話し合う',
'フォワード',
'同じような',
'ガイド',
'経験',
'スコア',
'リンゴ',
'買った',
'主導',
'ピッチ',
'コート',
'マス',
'カード',
'バンド',
'ロープ',
'スリップ',
'勝つ',
'夢',
'夕べ',
'条件',
'フィード',
'ツール',
'合計',
'基本',
'匂い',
'谷',
'も',
'ダブル',
'座席',
'続ける',
'ブロック',
'チャート',
'帽子',
'売る',
'成功',
'会社',
'引く',
'イベント',
'特定の',
'契約',
'泳ぐ',
'言葉',
'反対',
'妻',
'靴',
'肩',
'スプレッド',
'アレンジ',
'キャンプ',
'発明する',
'綿',
'ボルン',
'決定する',
'クォート',
'人',
'トラック',
'ノイズ',
'レベル',
'チャンス',
'集まる',
'ショップ',
'ストレッチ',
'投げる',
'輝き',
'財産',
'コラム',
'分子',
'選択する',
'間違った',
'グレー',
'リピート',
'必要とする',
'幅広い',
'準備する',
'塩',
'鼻',
'複数',
'怒り',
'請求',
'大陸']
